import type { ESN, TimestampInMillis } from '@cobliteam/common-types';
import type { Configuration, IRequest } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { DeviceTrip } from './Definitions';
import { deviceTripsTransformer } from './DeviceTripsTransformer';

export class DeviceTripsRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public getDeviceTrips = (deviceId: ESN, start: TimestampInMillis, end: TimestampInMillis, match = false): Promise<DeviceTrip> => {
    const requestData: IRequest = {
      endpoint: `/dash/device-trip?device_id=${deviceId}&start_time=${start}&end_time=${end}&match=${match}`,
      method: HttpMethod.GET,
    };

    return this.requester.request(requestData).then((response) => deviceTripsTransformer(response.data));
  };
}

export default DeviceTripsRequester;
